import * as ko from "knockout";
import { RNSAPI } from "../../api";
import { MainViewModel } from "../../main";
import '../dataTable/dataTable';
import '../appointment/daily';
import '../appointment/weekly';
import '../appointment/monthly';
import '../deadline/extend';
import '../deadline/delegate';
import '../calendar/calendar';
import '../note/notes';
import { DataTableViewModel, IntermediateListItem, Color } from '../dataTable/dataTable';
import { Utils } from '../../utils';
import * as moment from "moment"
import "../../../node_modules/moment/locale/de.js";
import * as fs from 'fs';

export class DashboardViewModel {
    appointments = ko.observableArray([]);
    deadlines = ko.observableArray([]);
    resubmissions = ko.observableArray([]);
    todos = ko.observableArray([]);
    lastWorkedOn = ko.observableArray([]);

    readonly DANGER_COLOR: Color = {
        color: "white",
        "background-color": "#b1436a"
    }

    currentView: KnockoutObservable<String>;

    viewTypes = [{ name: "Tagesansicht", view: "daily-view" }, { name: "Wochenansicht", view: "weekly-view" }];
    selectedType = ko.observable(this.viewTypes[0].view);

    pickedWeekDate = ko.observable(moment.utc().startOf("day"));

    today = () => this.pickedWeekDate(moment.utc().startOf("day"));

    nextInterval = () => {
        if (this.selectedType() === "weekly-view") {
            this.pickedWeekDate(this.startOfDay().clone().add(1, "week"))
        } else {
            this.pickedWeekDate(this.startOfDay().clone().add(1, "day"))
        }
    }

    previousInterval = () => {
        if (this.selectedType() === "weekly-view") {
            this.pickedWeekDate(this.startOfDay().clone().subtract(1, "week"))
        } else {
            this.pickedWeekDate(this.startOfDay().clone().subtract(1, "day"))
        }
    }

    startOfDay = ko.computed(() => {
        let weekDate = this.pickedWeekDate().clone();
        let selectedType = this.selectedType();

        if (selectedType === "weekly-view") {
            return weekDate.startOf("week");
        } else {
            return weekDate;
        }
    });

    endOfDay = ko.computed(() => {
        let weekDate = this.pickedWeekDate().clone();
        let selectedType = this.selectedType();

        if (selectedType === "weekly-view") {
            let startOfWeek = weekDate.startOf("week");
            return startOfWeek.clone().add(4, "days").endOf("day");
        } else {
            return weekDate.endOf("day");
        }
    });

    intervalText = ko.computed(() => {
        let startOfDay = this.startOfDay().clone();
        let endOfDay = this.endOfDay().clone();
        let selectedType = this.selectedType();

        if (selectedType === "weekly-view") {
            return `KW ${startOfDay.format("W")} \u2013 ${startOfDay.format("D. MMMM")} bis ${endOfDay.format("D. MMMM YYYY")}`;
        } else {
            return startOfDay.format("D. MMMM YYYY");
        }
    });

    startOfThisMonth: moment.Moment;
    startOfNextMonth: moment.Moment;

    deadlineToBeModified = ko.observable(null);

    constructor(params: any) {
        moment.locale("de");
        this.currentView = ko.observable(params.view);

        this.endOfDay.subscribe(() => this.update());

        this.startOfThisMonth = moment.utc().startOf("month");
        this.startOfNextMonth = moment.utc().startOf("month").add(1, "month");

        this.update();
    }

    public getVM = () => this;

    public showAppointments() {
        MainViewModel.RoutingTable.showDashboardView({ view: "appointments" }, true);
        this.currentView('appointments');
    }

    public showTodos() {
        MainViewModel.RoutingTable.showDashboardView({ view: "todos" }, true);
        this.currentView('todos');
    }

    public showLastWorkedOn() {
        MainViewModel.RoutingTable.showDashboardView({ view: "lastworkedon" }, true);
        this.currentView('lastworkedon');
    }

    transformAppointmentData(obj: any, type: string) {
        let color = Utils.isToday(moment.utc(obj.StartDate)) && !obj.Completed ? this.DANGER_COLOR : undefined;
        let actionList = [
            { icon: "pencil", name: "Edit", action: () => MainViewModel.RoutingTable.showAppointmentView({ id: obj.Id }) },
            { icon: "trash-o", name: "Löschen", action: async () => { await RNSAPI.deleteAppointment(obj.Id); this.update(); } },
        ];

        if (!obj.Completed) {
            actionList.push({ icon: "check", name: "Abhaken", action: async () => { await RNSAPI.completeAppointment(obj.Id); this.update(); } });
        }

        return new IntermediateListItem(type, nameTable[type], obj.StartDate, obj.AppointmentSubject, obj.CaseId, obj, actionList, color);
    }

    transformDeadlineData(obj: any, type: string) {
        let check = { icon: "check", name: "Abschließen", action: async () => { await RNSAPI.completeDeadline(obj); this.update(); } };
        let actionList = [
            {
                icon: "pencil", name: "Verlängern", action: async () => {
                    this.deadlineToBeModified(obj);
                    $('#extendDeadline').modal('show');
                }
            },
            {
                icon: "user-circle", name: "Delegieren", action: async () => {
                    this.deadlineToBeModified(obj);
                    $('#delegateDeadline').modal('show');
                }
            },
        ];

        if (obj.CompletionDate === null) actionList.push(check);

        let color = Utils.isToday(moment.utc(obj.Deadline)) ? this.DANGER_COLOR : undefined;

        return new IntermediateListItem(type, nameTable[type], obj.Deadline, obj.TypeId + obj.TypeDescription, obj.CaseId, obj, actionList, color);
    }

    transformResubmissionData(obj: any, type: string) {
        let color = Utils.isToday(moment.utc(obj.DeadLineDate)) ? this.DANGER_COLOR : undefined;
        return new IntermediateListItem(type, nameTable[type], obj.DeadLineDate, obj.DeadLineReason, obj.Case_ID || obj.Sachbearbeiter, obj, [
            { icon: "pencil", name: "Edit", action: async () => MainViewModel.RoutingTable.showResubmissionView({ id: obj.ID }) },
            { icon: "trash-o", name: "Löschen", action: async () => { await RNSAPI.deleteResubmission(obj.ID); this.update(); } },
        ], color);
    }

    transformECasesData(obj: any, type: string) {
        return new IntermediateListItem(type, nameTable[type], obj.LastChange || obj.DocumentDate || obj.RecordDate, obj.Subject, obj.CaseId, obj, [
            { icon: "pencil", name: "Edit", action: async () => MainViewModel.RoutingTable.showCaseEntryView({ caseId: obj.CaseId, eCaseRecordId: obj.Id }) },
            { icon: "trash-o", name: "Löschen", action: async () => { await RNSAPI.deleteRecord(obj.Id); this.update(); } },

            { icon: "eye", name: "Betrachten", action: async () => { MainViewModel.RoutingTable.showCaseEntriesView({ caseId: obj.CaseId, eCaseRecordId: obj.Id }) } },
        ]);
    }

    transformZPEData(obj: any, type: string) {
        return new IntermediateListItem(type, nameTable[type], obj.EMailDate, obj.Subject, obj.Sender, obj, [
            { icon: "eye", name: "Betrachten", action: async () => { MainViewModel.RoutingTable.showMailView({ accountId: obj.EMailAccountID, mailId: obj.RNSMail_ID }) } },
        ]);
    }

    async updateAppointments(allAppointments: any) {
        try {
            let appointments = allAppointments.Payload.Appointments.map(a => ({ ...a })).filter((a: any) => a.AppointmentType !== "F");
            let transformed = appointments.map(obj => {
                obj.actionHandlers = [
                    { icon: "pencil", name: "Edit", action: () => MainViewModel.RoutingTable.showAppointmentView({ id: obj.Id }) },
                    { icon: "trash-o", name: "Löschen", action: async () => { await RNSAPI.deleteAppointment(obj.Id); this.update(); } },
                ];
                return obj;
            });
            this.appointments(transformed);
        } catch (e) {
            console.log("Could not retrieve appointments.");
            console.log(e);
        }
    }

    async updateDeadlines(allDeadlines: any) {
        try {
            let deadlines = allDeadlines.Payload.Deadlines.map(d => ({ ...d })).filter(d => d.CompletionDate === null);
            let deadlinesSorted = deadlines.sort((d1, d2) => {
                if (moment.utc(d1.Deadline).isBefore(moment.utc(d2.Deadline))) {
                    return 1;
                } else {
                    return -1;
                }
            });
            let transformed = deadlinesSorted.map(obj => {
                let copy = $.extend(true, {}, obj);
                obj.columnActions = {
                    "CaseId": MainViewModel.RoutingTable.generateLink(`/caseentries/${encodeURIComponent(obj.CaseId)}`)
                };
                obj.actionHandlers = [
                    {
                        icon: "pencil", name: "Verlängern", action: async () => {
                            this.deadlineToBeModified(copy);
                            $('#extendDeadline').modal('show');
                        }
                    },
                    {
                        icon: "user-circle", name: "Delegieren", action: async () => {
                            this.deadlineToBeModified(copy);
                            $('#delegateDeadline').modal('show');
                        }
                    },
                    { icon: "check", name: "Abschließen", action: async () => { await RNSAPI.completeDeadline(copy); this.update(); } }
                ];
                obj.Deadline = (new Date(obj.Deadline)).toLocaleDateString();
                obj.PreDeadline = obj.PreDeadline ? (new Date(obj.PreDeadline)).toLocaleDateString() : "";
                obj.TypeDescription = obj.TypeId + obj.TypeDescription;
                return obj;
            });
            this.deadlines(transformed);
        } catch (e) {
            console.log("Could not retrieve deadlines.");
            console.log(e);
        }
    }

    async updateTodos(start: Date, end: Date, allAppointments: any, allDeadlines: any) {
        try {
            let zpeMails = (await RNSAPI.getZPE()).Payload.Emails;
            let transformedZPEEMails = zpeMails.map((zpeMail) => this.transformZPEData(zpeMail, "inbox"));
            let appointments = allAppointments.Payload.Appointments.filter((a: any) => a.AppointmentType !== "F" && !a.Completed)
            let deadlines = allDeadlines.Payload.Deadlines.filter(d => d.CompletionDate === null);
            let transformedAppointments = appointments.map(obj => this.transformAppointmentData(obj, "appointment"));
            let transformedDeadlines = deadlines.map(obj => this.transformDeadlineData(obj, "deadline"));
            let resubmissions = (await RNSAPI.getResubmissionsByRange({ StartDate: start.toISOString(), EndDate: end.toISOString() })).Payload.Resubmissions;
            let transformedResubmissions = resubmissions.map(obj => this.transformResubmissionData(obj, "resubmission"));
            let ecases = (await RNSAPI.getCaseEntriesForWorkFlow("PE")).Payload.Records;
            let transformedECases = ecases.map(obj => this.transformECasesData(obj, "ecase"));
            let todos = (transformedAppointments.concat(transformedDeadlines)
                .concat(transformedResubmissions)
                .concat(transformedZPEEMails)
                .concat(transformedECases));
            let sortedTodos = todos.sort((t1: IntermediateListItem, t2: IntermediateListItem) => {
                if (t1.dateObj.isBefore(t2.dateObj)) {
                    return 1;
                } else {
                    return -1;
                }
            });

            var Heute = new Date();
            var TheDay = Heute.getDate();
            var TheMonth = Heute.getMonth()+1;
            var TheYear = Heute.getFullYear();
            var Heutee = "";

            if (TheDay < 10) {
                Heutee += "0" + TheDay;
            }
            else {
                Heutee += TheDay;
            }

            if (TheMonth < 10) {
                Heutee += '.0' + TheMonth;
            }
            else {
                Heutee += '.' + TheMonth
            }

            Heutee += '.' + TheYear;     

            
            let transformed = sortedTodos.map(obj => {
                let copy = $.extend(true, {}, obj);
                if (obj.date === Heutee) {
                    if (obj.entryTypeName === "Frist" || obj.entryTypeName === "EAkte") {
                        obj.columnActions = {
                            "number": MainViewModel.RoutingTable.generateLink(`/caseentries/${encodeURIComponent(obj.number)}`)
                        };
                    }
                    return obj;
                }
                else {
                    for (var i = 0; i <= sortedTodos.length - 1; i++) {
                        //console.log("Schleife");
                        //console.log(sortedTodos[i]);
                        if (sortedTodos[i].date !== Heutee) {
                            sortedTodos.splice(i, 1);
                        }
                    }
                }

               
            });
            this.todos(sortedTodos);
       
        } catch (e) {
            console.log("Could not retrieve todos.");
            console.log(e);
        }
    }

    async updateLastWorkedOn(start: Date, end: Date) {
        try {
            let allAppointments = await RNSAPI.getAppointments(start, end);
            let appointments = allAppointments.Payload.Appointments.filter((a: any) => a.AppointmentType !== "F" && a.Completed)
            let deadlines = (await RNSAPI.getDeadlines(moment(start))).Payload.Deadlines.filter(d => d.CompletionDate !== null);
            let transformedAppointments = appointments.map(obj => this.transformAppointmentData(obj, "appointment"));
            let transformedDeadlines = deadlines.map(obj => this.transformDeadlineData(obj, "deadline"));
            let resubmissions = (await RNSAPI.getResubmissionsByRange({ StartDate: start.toISOString(), EndDate: end.toISOString() })).Payload.Resubmissions;
            let transformedResubmissions = resubmissions.map(obj => this.transformResubmissionData(obj, "resubmission"));
            let lastWorkedOn = (transformedAppointments.concat(transformedDeadlines)
                .concat(transformedResubmissions));
            let lastWorkedOnSorted = lastWorkedOn.sort((t1: IntermediateListItem, t2: IntermediateListItem) => {
               
                if (t1.dateObj.isBefore(t2.dateObj)) {
                    return 1;
                } else {
                    return -1;
                }
            });

            let transformed = lastWorkedOnSorted.map(obj => {
                let copy = $.extend(true, {}, obj);
                obj.columnActions = {
                    "number": MainViewModel.RoutingTable.generateLink(`/caseentries/${encodeURIComponent(obj.number)}`)
                };
                return obj;
            });
            this.lastWorkedOn(transformed);
            this.lastWorkedOn(lastWorkedOnSorted);
        } catch (e) {
            console.log("Could not retrieve lastWorkedOn.");
            console.log(e);
        }
    }

    async update() {
        let allAppointments = await RNSAPI.getAppointments(this.startOfDay().toDate(), this.endOfDay().toDate())
        let allDeadlines = await RNSAPI.getDeadlines(this.startOfDay())
        this.updateAppointments(allAppointments);
        this.updateDeadlines(allDeadlines);
        this.updateTodos(this.startOfDay().toDate(), this.endOfDay().toDate(), allAppointments, allDeadlines);
        this.updateLastWorkedOn(this.startOfDay().clone().subtract(1, 'days').toDate(), this.endOfDay().clone().subtract(1, 'days').toDate());
    }
}


let nameTable: { [key: string]: string; } = {
    "appointment": "Termin",
    "deadline": "Frist",
    "inbox": "Posteingang",
    "resubmission": "Wiedervorlage",
    "ecase": "EAkte"
};

var html = fs.readFileSync(__dirname + '/dashboard.html', 'utf8');

ko.components.register("dashboard-view", {
    viewModel: DashboardViewModel,
    template: html
});
